<template>
    <div class="global-information">
        <div class="global-view-info-container">
            <h2 class="card-title">{{ $store.getters.currentEntity.display_name }} <span class="light">- global view</span></h2>
            <ns-loader
                :to-load="toLoad"
                class="full-size"
                style="margin-top: 15px; position: relative;"
                @dataFetched="onDataFetched"
            >
                <div slot="loader">
                    <loading-template></loading-template>
                </div>
                <template slot="content">
                    <div class="global-view-content">
                        <div>
                            <div class="big-numbers-title">Running feeds</div>
                            <div class="big-numbers">
                                {{ runningFeeds }}
                            </div>
                        </div>
                        <div>
                            <div class="big-numbers-title" style="margin-bottom: 15px;">
                                next feed <template v-if="nextFeedStartDate">begins in</template>
                            </div>
                            <div>
                                <next-comming-feed :targetDate="nextFeedStartDate"></next-comming-feed>
                            </div>
                        </div>
                    </div>
                    <div class="global-view-content">
                        <div>
                            <div class="big-numbers-title">available FEEDS for the next 30 days</div>
                            <div class="big-numbers">
                                {{ scheduledFeeds }}
                            </div>
                        </div>
                        <div>
                            <div class="big-numbers-title">configured FEEDS for the next 30 days</div>
                            <div class="big-numbers">
                                {{ availableConfigurations }}
                            </div>
                        </div>
                    </div>
                </template>
            </ns-loader>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { NextCommingFeed, LoadingTemplate } from 'gcmcn-common';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import InfoMixin  from '../../partials/global-view-info-mixin.vue';
export default {
    mixins: [InfoMixin],
    components: {
        NextCommingFeed,
        NsLoader,
        LoadingTemplate,
    },

    props: {

    },

    data (){
        return {
        };
    },
    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.global-information {
    .card-title {
        font-family: "Roboto Black" !important;
        font-size: 18px;
        .light {
            font-family: "Roboto Light" !important;
        }
    }
    .global-view-content{
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        margin-top: 27px;
        & > div{
            flex-basis: 45%;
            margin-bottom: 17px;
            &:nth-child(even){
                margin-left: 5%;
            }
            &:nth-child(odd){
                margin-right: 5%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/global-informations.vue